import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/dashboard';
import api from '~/services/api';

function* loadDashboard({ partner, params }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/stats`, {
      params
    });
    yield put(actions.loadDashboardSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [takeLatest(Types.LOAD_DASHBOARD, loadDashboard)];

export default sagas;
